import React from "react";
import { connect } from "react-redux";
import { toggleCollectionPageOverlay } from "../../redux/actions";
import { Header, SelectButton } from "../../components";
import Footer from "../../components/Footer/Footer";
import "./_CollectionPage.scss";
import { ReactComponent as ArrowUpRight } from "../../assets/svg/arrow_up_right.svg";

import CollectionSelect from "../../components/CollectionSelect/CollectionSelect";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

class CollectionPage extends React.Component {
  renderModal = () => {
    const {
      showOverlay,
      overlayTitleText,
      overlayDescriptionText,
      overlayButtonText,
    } = this.props;

    const html = overlayDescriptionText
      ? documentToHtmlString(overlayDescriptionText)
      : "";

    if (showOverlay) {
      return (
        <div id="modal">
          <div className="modal-content">
            <span className="modal-title">{overlayTitleText}</span>
            <div className="modal-underline"></div>
            <div
              className="modal-text"
              id="modal-rich-text"
              dangerouslySetInnerHTML={{ __html: html }}
            ></div>
            <SelectButton
              buttonText={overlayButtonText}
              color="copper"
              onClick={() => this.props.toggleCollectionPageOverlay()}
            />
          </div>
        </div>
      );
    }
  };

  render() {
    const {
      pageTitleText,
      backButtonText,
      collectionLinkURL,
      collectionLinkText,
    } = this.props;

    return (
      <div className="collection-page ojl-configurator-page">
        <Header titleText={pageTitleText} />
        <CollectionSelect />
        <a href={collectionLinkURL} className="collection-link">
          {collectionLinkText}
          <ArrowUpRight className="arrow-up-right" />
        </a>
        <Footer backButtonText={backButtonText} showBackButton />
        {this.renderModal()}
      </div>
    );
  }
}

const mapStateToProps = ({ collectionPage }) => {
  const {
    pageTitleText,
    overlayTitleText,
    overlayDescriptionText,
    overlayButtonText,
    selectButtonText,
    collectionLinkText,
    collectionLinkURL,
    backButtonText,
    showOverlay,
  } = collectionPage;

  return {
    pageTitleText,
    overlayTitleText,
    overlayDescriptionText,
    overlayButtonText,
    selectButtonText,
    collectionLinkText,
    collectionLinkURL,
    backButtonText,
    showOverlay,
  };
};

export default connect(mapStateToProps, {
  toggleCollectionPageOverlay,
})(CollectionPage);
